import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

/** Gate for non-sign-in pages. Checks only that a token EXISTS — the server is the
 *  authority on validity and 401s every /api route outside sign-in. `replace` keeps
 *  the guarded URL out of history. */
export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }
  return children;
}
